import axios from '../host';

export const getWanderlandsOfStudent = (studentId) => {
  return axios.get(`/api/v2/students/${studentId}/wanderlands`);
};

export const getWanderlandOfStudent = (studentId, wanderlandId) => {
  return axios.get(
    `/api/v2/students/${studentId}/wanderlands/${wanderlandId}`
  );
};

// export const getWanderlandStagesOfStudent = (studentId, wanderlandId) => {
//   return axios.get(
//     `/api/v2/student/${studentId}/wanderlands/${wanderlandId}/stages`
//   );
// };

export const getWanderlandStage = (studentId, wanderlandStageId) => {
  return axios.get(
    `/api/v2/students/${studentId}/wanderland-stages/${wanderlandStageId}`
  );
};

export const setPassWanderlandStage = (studentId, wanderlandStageId) => {
  const body = JSON.stringify({ wanderlandStageId });
  return axios.post(
    `/api/v2/students/${studentId}/pass-wanderland-stage`,
    body
  );
};

export const getWanderlandQuestions = (wanderlandId) => {
  return axios.get(`/api/v2/wanderlands/${wanderlandId}/questions`);
};

export const getBossRanks = () => {
  return axios.get('/api/v2/boss-ranks');
}
